import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextTemplateTypeModel } from 'src/app/models/text-templates/text-template-type.model';
import { UserContextService } from 'src/app/services/user-context.service';

@Component({
  selector: 'app-training-cancel-dialog',
  templateUrl: './training-cancel-dialog.component.html',
  styleUrl: './training-cancel-dialog.component.scss',
  standalone: false
})
export class TrainingCancelDialogComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() submit = new EventEmitter();

  textTemplateType: TextTemplateTypeModel = 
    TextTemplateTypeModel.CancelMeeting;

  formData = {
    infoInput: '',
    infoCheckbox: '',
  };

  constructor(
    public userContext: UserContextService
  ) {}
  
  dismiss = () => {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  };

  onSubmit = () => {
    this.submit.emit({
      cancelInformationText: this.formData.infoCheckbox
        ? this.formData.infoInput
        : null,
    });
  };

  onTemplateContentChanged(content: string) {
    this.formData.infoInput = content;
  }
}

export interface TrainingCancelDialogResult {
  cancelEvent: boolean;
  cancelInformationText: string | null;
}
